import { useEffect, useState } from 'react';
import { mount } from 'selfService/SelfServiceApp';
import { useMicrofrontend } from 'ui/hooks/useMicrofrontend';
import { Layout } from 'ui/components';

export type MFSelfServiceParams = {
  document?: string;
};

const MfSelfService = ({ ...props }) => {
  const params = props as MFSelfServiceParams;
  const [isLoaded, setIsLoaded] = useState(false);
  const { mfElementRef } = useMicrofrontend(mount, params.document);

  useEffect(() => {
    window?.newrelic?.addPageAction('self-service-loading');

    if (mfElementRef.current) {
      setIsLoaded(true);

      window?.newrelic?.addPageAction('self-service-loaded');
    }
  }, [mfElementRef]);

  return (
    <>
      {!isLoaded && <Layout horizontalAlign="left" fullPage loading />}
      <div ref={mfElementRef} id="self-service-main-container" />
    </>
  );
};

export default MfSelfService;
